<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin class="relative">
    <ng-container *ngIf="unreadCount > 0">
        <span
            class="absolute top-0.5 right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 text-white text-[10px] font-bold px-1 animate-pulse shadow-md"
        >
            {{ unreadCount }}
        </span>
    </ng-container>
    <mat-icon 
        [svgIcon]="'heroicons_outline:exclamation-triangle'" 
        [ngClass]="{ 'text-amber-500': unreadCount > 0, 'text-gray-400': unreadCount === 0 }"
    ></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div
        class="box-section fixed inset-0 sm:static sm:inset-auto flex flex-col sm:rounded-2xl overflow-hidden shadow-lg bg-white dark:bg-slate-900 sm:min-w-96 sm:w-96 !p-0"
        [style.--box-border-color]="color_primario || ''"
    >
        <!-- Header -->
        <div
            [@expandCollapse]="'expanded'"
            class="w-full flex gap-4 justify-between items-center p-4 border-b border-gray-100"
        >
            <div class="flex items-center gap-2">
                <!-- Botón Volver (sólo visible en detalle de grupo) -->
                <button
                    *ngIf="showNotifications"
                    class="w-8 h-8 min-h-8 rounded-full hover:bg-gray-100 transition-colors mr-0"
                    mat-icon-button
                    matTooltip="Volver atrás"
                    (click)="showNotifications = false"
                >
                    <mat-icon
                        [style.color]="color_primario || ''"
                        class="icon-size-5"
                        svgIcon="keyboard_arrow_left"
                    >
                    </mat-icon>
                </button>
                
                <app-section-title 
                    [title]="showNotifications && grupoSeleccionado ? grupoSeleccionado.title : 'Alertas de Gestión'" 
                    [color]="showNotifications ? 'transparent' : color_primario"
                    [class.!pl-0]="showNotifications"
                ></app-section-title>

                <!-- Badge con el total del grupo si está en vista detalle -->
                <span
                    *ngIf="showNotifications && notifications?.length > 0"
                    [style.background-color]="color_primario ? color_primario + '1A' : ''"
                    [style.color]="color_primario || ''"
                    [style.border-color]="color_primario ? color_primario + '4D' : ''"
                    class="px-2 py-0.5 text-xs font-bold rounded-full border ml-1"
                >
                    {{ notifications.length }}
                </span>
            </div>
            <div>
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div
            class="relative flex flex-col flex-auto sm:max-h-120 divide-y divide-gray-100 overflow-y-auto bg-card"
        >
            <!-- Notifications Group -->
            <div *ngIf="!showNotifications">
                <ng-container
                    *ngFor="
                        let notification of notifications_group;
                        trackBy: trackByFn
                    "
                >
                    <div
                        (click)="verMasNotificaciones(notification)"
                        class="flex group hover:bg-amber-50/30 dark:hover:bg-black dark:hover:bg-opacity-5 cursor-pointer transition-colors duration-150 ease-in-out"
                    >
                        <div class="flex flex-auto py-4 pl-6">
                            <ng-container
                                *ngTemplateOutlet="notificationContent"
                            ></ng-container>
                        </div>

                        <!-- Actions -->
                        <div class="relative flex flex-col justify-center my-4 mr-6 ml-2">
                            <!-- Group -->
                            <button
                                class="w-8 h-8 min-h-8 rounded-full hover:bg-gray-100 transition-colors"
                                mat-icon-button
                                matTooltip="Ver detalles"
                                (click)="verMasNotificaciones(notification)"
                            >
                                <mat-icon
                                    [style.color]="color_primario || ''"
                                    class="icon-size-5 transition-colors"
                                    svgIcon="keyboard_arrow_right"
                                >
                                </mat-icon>
                            </button>
                        </div>
                    </div>

                    <!-- Notification content template -->
                    <ng-template #notificationContent>
                        <!-- Icon -->
                        <ng-container
                            *ngIf="notification.icon && !notification.image"
                        >
                            <div
                                [style.background-color]="color_primario ? color_primario + '1A' : ''"
                                [style.border-color]="color_primario ? color_primario + '4D' : ''"
                                class="flex shrink-0 items-center justify-center w-11 h-11 mr-4 rounded-xl border border-solid"
                            >
                                <mat-icon
                                    [style.color]="color_primario || ''"
                                    class="icon-size-6"
                                    [svgIcon]="notification.icon"
                                >
                                </mat-icon>
                            </div>
                        </ng-container>
                        <!-- Image -->
                        <ng-container *ngIf="notification.image">
                            <img
                                class="shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                                [src]="notification.image"
                                [alt]="'Notification image'"
                            />
                        </ng-container>
                        <!-- Title, description & time -->
                        <div class="flex flex-col flex-auto justify-center">
                            <ng-container *ngIf="notification.title">
                                <div class="flex justify-between">
                                    <div
                                        class="font-semibold text-gray-800 dark:text-gray-200 text-sm tracking-tight"
                                        [innerHTML]="notification.title"
                                    ></div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="notification.description">
                                <div
                                    class="text-xs text-gray-500 dark:text-gray-400 mt-0.5"
                                    [innerHTML]="notification.description"
                                ></div>
                            </ng-container>
                        </div>
                    </ng-template>
                </ng-container>
            </div>

            <!-- Notifications -->
            <div *ngIf="showNotifications">
                <ng-container
                    *ngFor="
                        let notification of paginatedNotifications;
                        trackBy: trackByFn
                    "
                >
                    <div
                        [@expandCollapse]="'expanded'"
                        class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 relative"
                        [matTooltip]="notification.description"
                        matTooltipClass="tooltip-wrap"
                        matTooltipPosition="left"
                    >
                        <!-- Notification with a link -->
                        <ng-container *ngIf="notification.link">
                            <!-- Normal links -->
                            <ng-container *ngIf="!notification.useRouter">
                                <a
                                    class="flex flex-auto py-5 pl-6 pr-6 cursor-pointer"
                                    [routerLink]="notification.link"
                                    (click)="closePanel()"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="notificationContent"
                                    ></ng-container>
                                </a>
                            </ng-container>
                            <!-- Router links -->
                            <ng-container *ngIf="notification.useRouter">
                                <a
                                    class="flex flex-auto py-5 pl-6 pr-6 cursor-pointer"
                                    [routerLink]="notification.link"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="notificationContent"
                                    ></ng-container>
                                </a>
                            </ng-container>
                        </ng-container>

                        <!-- Notification without a link -->
                        <ng-container *ngIf="!notification.link">
                            <div class="flex flex-auto py-5 pl-6 pr-6">
                                <ng-container
                                    *ngTemplateOutlet="notificationContent"
                                ></ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <!-- Notification content template -->
                    <ng-template #notificationContent>
                        <!-- Icon -->
                        <ng-container
                            *ngIf="notification.icon && !notification.image"
                        >
                            <div
                                [style.background-color]="color_primario ? color_primario + '1A' : ''"
                                [style.border-color]="color_primario ? color_primario + '4D' : ''"
                                class="flex shrink-0 items-center justify-center w-11 h-11 mr-4 rounded-xl border border-solid"
                            >
                                <mat-icon
                                    [style.color]="color_primario || ''"
                                    class="icon-size-6"
                                    [svgIcon]="notification.icon"
                                >
                                </mat-icon>
                            </div>
                        </ng-container>
                        <!-- Image -->
                        <ng-container *ngIf="notification.image">
                            <img
                                class="shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                                [src]="notification.image"
                                [alt]="'Notification image'"
                            />
                        </ng-container>
                        <!-- Title, description & time -->
                        <div class="flex flex-col flex-auto">
                            <ng-container *ngIf="notification.title">
                                <div class="flex justify-between items-start mb-2">
                                    <div
                                        class="font-semibold flex items-center flex-wrap gap-2"
                                    >
                                        <span [innerHTML]="notification.title"></span>
                                        <!-- Badge de Criticidad -->
                                        <span
                                            [ngClass]="{
                                                'bg-red-100 text-red-700 border-red-200': (notification.title?.toLowerCase().includes('vencido') || notification.title?.toLowerCase().includes('vencida') || notification.title?.toLowerCase().includes('impaga') || notification.title?.toLowerCase().includes('impago')),
                                                'bg-amber-100 text-amber-700 border-amber-200': !(notification.title?.toLowerCase().includes('vencido') || notification.title?.toLowerCase().includes('vencida') || notification.title?.toLowerCase().includes('impaga') || notification.title?.toLowerCase().includes('impago'))
                                            }"
                                            class="px-2 py-0.5 text-[10px] font-bold uppercase rounded-full border"
                                        >
                                            {{ (notification.title?.toLowerCase().includes('vencido') || notification.title?.toLowerCase().includes('vencida') || notification.title?.toLowerCase().includes('impaga') || notification.title?.toLowerCase().includes('impago')) ? 'Vencido' : 'Pendiente' }}
                                        </span>
                                    </div>
                                    <div
                                        class="text-sm leading-none text-secondary mt-1 whitespace-nowrap"
                                    >
                                        {{
                                            notification.date | date : "dd MMMM"
                                        }}
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="notification.description">
                                <div
                                    class="text-sm text-secondary"
                                    [innerHTML]="notification.description"
                                ></div>
                            </ng-container>
                        </div>
                    </ng-template>
                </ng-container>

            </div>

            <!-- No notifications -->
            <ng-container
                *ngIf="!notifications_group || !notifications_group.length"
            >
                <div
                    class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8"
                >
                    <div
                        [class]="color_primario ? '' : default_color"
                        [style.background-color]="color_primario"
                        class="flex flex-0 items-center justify-center w-14 h-14 rounded-full"
                    >
                        <mat-icon
                            class="text-white"
                            [svgIcon]="'heroicons_outline:exclamation-triangle'"
                        ></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">
                        No tienes alertas
                    </div>
                    <div
                        class="w-full max-w-60 mt-1 text-md text-center text-secondary"
                    >
                        Cuando tengas alertas críticas o informativas se mostrarán aquí.
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Paginador Customizado Minimalista (Fijo en el pie del panel) -->
        <div
            *ngIf="showNotifications && notifications && notifications.length > 5"
            class="flex items-center justify-between px-6 py-3 border-t border-gray-100 bg-gray-50 dark:bg-slate-800/50 shrink-0 text-sm"
        >
            <!-- Rango / Total -->
            <div class="text-secondary font-medium">
                Mostrando <span class="font-bold text-gray-800 dark:text-gray-100">{{ (pageIndex * pageSize) + 1 }}</span> al 
                <span class="font-bold text-gray-800 dark:text-gray-100">{{ ((pageIndex + 1) * pageSize) > notifications.length ? notifications.length : ((pageIndex + 1) * pageSize) }}</span> de 
                <span class="font-bold text-gray-800 dark:text-gray-100">{{ notifications.length }}</span>
            </div>

            <!-- Controles de Navegación -->
            <div class="flex items-center gap-1">
                <!-- Anterior -->
                <button
                    mat-icon-button
                    [disabled]="pageIndex === 0"
                    (click)="onPageChange({ pageIndex: pageIndex - 1, pageSize: pageSize })"
                    class="w-8 h-8 min-h-8 rounded-lg"
                    [style.color]="pageIndex !== 0 ? color_primario : ''"
                >
                    <mat-icon class="icon-size-5" svgIcon="keyboard_arrow_left"></mat-icon>
                </button>

                <!-- Siguiente -->
                <button
                    mat-icon-button
                    [disabled]="((pageIndex + 1) * pageSize) >= notifications.length"
                    (click)="onPageChange({ pageIndex: pageIndex + 1, pageSize: pageSize })"
                    class="w-8 h-8 min-h-8 rounded-lg"
                    [style.color]="((pageIndex + 1) * pageSize) < notifications.length ? color_primario : ''"
                >
                    <mat-icon class="icon-size-5" svgIcon="keyboard_arrow_right"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-template>
